

interface Props {
    modelId: string;
    title: string;
    body: JSX.Element
    noTitle: string;
    yesTitle: string;
    noFunction: () => void;
    yesFunction: () => void;
}

const Model: React.FC<Props> = ({ modelId, title, body, noTitle, yesTitle, noFunction, yesFunction }): JSX.Element => {
    return (
        <div id={modelId} className="modal">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {body}
                    </div>
                    <div className="modal-footer">
                        <button onClick={noFunction} type="button" className="btn btn-secondary" data-bs-dismiss="modal">{noTitle}</button>
                        <button onClick={yesFunction} type="button" className="btn btn-primary" data-bs-dismiss="modal">{yesTitle}</button>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Model;

/*

*/